import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE SYSTEMCOLORS
 */
function MLBWideLineConversion() {
  return (
    <Crud
      title="MLB Wide Line Conversion"
      getUrl={() => "/Profile/MLBWideLine_GetList"}
      // INSERT
      insertUrl={() => "/Profile/MLBWideLine_Insert"}
      insertParams={({ userId }, { maxOdds, minOdds, favOdds, dogOdds }) => ({
        MaxOdds: maxOdds,
        MinOdds: minOdds,
        FavOdds: favOdds,
        DogOdds: dogOdds,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Profile/MLBWideLine_Update"}
      updateParams={({ userId }, { idMLBWideLine, maxOdds, minOdds, favOdds, dogOdds }) => ({
        IdMLBWideLine: idMLBWideLine,
        MaxOdds: maxOdds,
        MinOdds: minOdds,
        FavOdds: favOdds,
        DogOdds: dogOdds,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Profile/MLBWideLine_Delete"}
      deleteParams={({ userId }, id) => ({
        IdMLBWideLine: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idMLBWideLine"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataField="minOdds">Min ML Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="maxOdds">Max ML Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="dogOdds">Dog Eastern Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="favOdds">Fav Eastern Odds</TableHeaderColumn>
    </Crud>
  );
}

export default MLBWideLineConversion;
